module.exports = __webpack_public_path__ + "static/media/abilities_map_icon.ccbe4a3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/abilities_map_icon.svg
// module id = 1928
// module chunks = 0